import { axios } from '@Root/API'

export const getAll = params => {
	return axios.get('venues-all', { params })
}
